<template>
  <div class="border-t border-gray-200">
    <basic-checkbox v-model="active" class="py-2 px-3" :label="label" />
    <div class="py-2 px-3 bg-gray-50" v-if="active">
      <div v-for="option in options" :key="option.value" class="mb-1">
        <div class="relative flex items-start">
          <div class="absolute flex items-center h-5">
            <input
              type="checkbox"
              :value="option.value"
              v-model="value"
              class="form-checkbox h-4 w-4 text-gray-600 transition duration-150 ease-in-out"
            />
          </div>
          <div class="pl-7 text-sm leading-5">
            <label for v-text="option.label"></label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BasicCheckbox from "@/components/basic/Checkbox";

export default {
  components: { BasicCheckbox },

  props: {
    name: {
      required: true,
      type: String
    },
    label: {
      required: true,
      type: String
    },
    options: {
      required: false,
      type: Array
    }
  },

  inject: ["registerFilter"],

  mounted() {
    let filter = this.registerFilter(this.formatFilter());

    // Value is in string format with "," as seperator
    //this.value = filter.value.split(",").filter(Boolean); // Filter all empty values;

    //this.active = this.value.length > 0;
  },

  data() {
    return {
      active: false,
      value: []
    };
  },

  watch: {
    active(value) {
      if (value) return;

      this.value = [];
    }
  },

  methods: {
    formatFilter() {
      return {
        name: this.name,
        setValue: this.setValue,
        getValue: this.getValue,
        getActive: () => this.active //TODO Validate if everything is correct and if active is true
      };
    },

    setValue(value) {
      this.active = value.length > 0;
      this.value = value.split(",").filter(Boolean); // Filter all empty values;
    },

    getValue() {
      return this.value.join(",");
    }
  }
};
</script>